import React from 'react';
import { Icon } from '../../icons';

/**
 * Empty state with brand animated SVG icon + entrance motion.
 * Use on rare/occasional views (search no-results, dashboard empty slots).
 */
export function AnimatedEmptyState({
  icon = 'loader-running-dog',
  title,
  description,
  action,
  className = '',
}) {
  return (
    <div className={`empty-state pf-empty-state-animated ${className}`.trim()}>
      <div className="pf-empty-state-icon">
        <Icon name={icon} size="2xl" decorative />
      </div>
      {title ? (
        <h3 className="text-xl font-semibold text-[var(--pf-ink)] mb-2">{title}</h3>
      ) : null}
      {description ? (
        <p className="text-[var(--pf-ink-muted)] mb-6 max-w-md mx-auto">{description}</p>
      ) : null}
      {action}
    </div>
  );
}

export default AnimatedEmptyState;
